import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'virtues-bootstrap';
import cx from 'classnames';
import s from './styles.module.scss';

const AdaptiveDataRow = ({
  withLabelMargin,
  icon,
  className,
  iconClassName,
  title,
  horizontalMargin,
  children,
  titleSizes,
  contentSizes,
}) => (
  <Row className={cx(s.rowMargin, className)}>
    <Col className={s.noPaddingLeft} {...titleSizes}>
      <div className={cx(s.labelWrap, { [s.horizintalRowMargin]: horizontalMargin })}>
        {icon && <div className={cx(s.icon, iconClassName)}>{icon}</div>}
        <Label className={cx({ [s.label]: withLabelMargin })}>{title}</Label>
      </div>
    </Col>
    <Col className={s.noPadding} {...contentSizes}>
      {children}
    </Col>
  </Row>
);

AdaptiveDataRow.defaultProps = {
  className: null,
  iconClassName: null,
  icon: null,
  titleSizes: {
    sm: 5,
    md: 5,
    lg: 4,
  },
  contentSizes: {
    sm: 7,
    md: 7,
    lg: 8,
  },
  withLabelMargin: false,
  horizontalMargin: false,
  title: null,
};

AdaptiveDataRow.propTypes = {
  titleSizes: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
  }),
  contentSizes: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
  }),
  icon: PropTypes.node,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  withLabelMargin: PropTypes.bool,
  horizontalMargin: PropTypes.bool,
};

export default AdaptiveDataRow;
